import { Modal } from "antd";

const DeleteComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => {},
    onOk = () => {},
    formVal
  } = props

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={()=> onOk(formVal.id)}
      cancelText="取消"
      okText="确认"
    >
      {/* <p>确认删除 {formVal.title} 推荐商品吗?</p> */}
      <p>确认删除 {formVal.productDetail ? formVal.productDetail.name : formVal.title} 推荐商品吗?</p>
    </Modal>
  )
}

export default DeleteComponent